const template = document.createElement("template");
template.innerHTML = `
<style>
div.container {
    min-width: 10em;
    padding: 5px;
    margin: 0 2px;
    display: flex;
}
div.container.linked {
  cursor: pointer;
}

span.label {
  flex-grow: 1;
  white-space: nowrap;
  padding-right: 2em;
}
span.count {
  background-color: #d71f85;
  color: white;
  border-radius: 4px;
  padding: 1px 6px;
}

</style>
<div class="container">
<span class="label"></span>
<span class="count"></span>
</div>
`;
export class NotificationCountElement extends HTMLElement {
    private _shadowRoot: ShadowRoot;
    constructor() {
        super();
        this._shadowRoot = this.attachShadow({ mode: "open" });
        this._shadowRoot.appendChild(template.content.cloneNode(true));
        this.render();
    }
    static get observedAttributes() {
      return ["label", "count", "url"];
    }
    private attributeChangedCallback(name, oldValue, newValue) {
      this.render();
    }

    private render() {
      this._shadowRoot.querySelector(".label").innerHTML = this.getAttribute("label");
      this._shadowRoot.querySelector(".count").innerHTML = this.getAttribute("count");
      if (this.getAttribute("url") != null) {
        this._shadowRoot.querySelector(".container").classList.add("linked");
        this._shadowRoot.addEventListener("click",
          () => {
            window.location.href = this.getAttribute("url");
          },
        );
      }

    }
}
export interface NotificationCountData {
  label: string;
  translate?: boolean;
  count: number;
  url: string;
}

export function initNotificationCountWebComponent() {
    window.customElements.define("notification-count", NotificationCountElement);
}
